import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import { getUserByEmail } from '../../services/api/user';

import { APP_URL } from '../../util/constants/APP_URL';

import asgImage from '../../assets/images/ASG.png';
import femaleMaleImage from '../../assets/images/female_male.png';
import misionImage from '../../assets/images/MISION.png';

const Recuperar = () => {
    const navigate = useNavigate()
    const validationSchema = Yup.object().shape({
        email: Yup.string()
                .email()
                .matches(/^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/, 'Debe ingresar un correo válido.')
                .required('Debe ingresar un correo válido.')
    });
    const formOptions = { resolver: yupResolver(validationSchema) };

    const { register, handleSubmit, formState: { isValid }, reset } = useForm({
        mode: 'onChange',
        ...formOptions
    });

    const [error, setError] = useState<string>('')
    const [success, setSuccess] = useState<string>('')

    const redirectoTo = (url: string) => {
        navigate(url)
    }
 
    const onSubmit = async (data: any) => {
        setError('')

        if (isValid) {
            getUserByEmail({ email: data.email })
            .then(response => {
                if (!response?.status) {
                    setError(response?.message)
                }
                else {
                    setSuccess(response.message)
                    reset()
                }
            })
        }
    };
  
    return (
        <section className="background-form">
            <div className="image-section">
                <div>
                    <div>
                        <img src={femaleMaleImage} alt="mision" />
                    </div>
                </div>  
            </div>
            <div className="width-full height-full">
                <div className="pt-8-per left-0 right-0">
                    <div className="bar-asg">
                        <div>
                            <img src={misionImage} alt="mision" />
                            <img src={asgImage} alt="ASG" />
                        </div>
                    </div>
                </div>
                <div className="width-full flex justify-content-center align-center relative">
                    <div className="inputs-section login-inputs">
                        <div>
                            <p className="title ft-EricssonGA628">RECUPERAR CONTRASEÑA</p>
                            <div className="form">
                                <form>
                                    <div className="form-section">
                                        <input 
                                            type="text"
                                            placeholder="Escribe tu correo"
                                            {...register("email", {
                                                required: "Correo es obligatorio."
                                            })}
                                            onKeyDown={(e) => {
                                            if (e.key === " ") e.preventDefault();
                                            }}
                                        />
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="flex justify-content-center align-items-center gap-4 button-submit flex-column">
                            <button onClick={handleSubmit(onSubmit)} disabled={!isValid}>
                                <span className="ft-EricssonGA628">Enviar</span>
                            </button>
                            <p className="pie-title ft-EricssonGA628 pointer" onClick={() => redirectoTo(APP_URL.AUTHENTICATION.LOGIN)}>Iniciar sesión</p>
                        </div>                            
                        <div className="error-section">
                           {
                            error &&
                            <p className="ft-EricssonGA628">{ error }</p>
                           }
                           {
                            success &&
                            <p className="ft-EricssonGA628 success">{ success }</p>
                           }
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Recuperar;